module.exports = __webpack_public_path__ + "media/images/battery_green-f2ababed87e48476d4a52572ca1824ae.png";